import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';

import { withSearchHandler } from 'decorators';
import { Container } from 'components/core/Page';
import { HH, H2 } from 'components/core/Headline';
import { Paragraph } from 'components/core/Typography';
import { SearchBox } from 'components/search/SearchBox';
import { StickySearchBar } from 'components/landing/StickySearchBar';
import { Search } from 'components/svg';

import comparePrices from 'assets/images/icons/search-hero/compare-prices.svg';
import exclusiveDeals from 'assets/images/icons/search-hero/exclusive-deals.svg';
import freeReservation from 'assets/images/icons/search-hero/free-reservation.svg';
import noCreditCard from 'assets/images/icons/search-hero/no-credit-card.svg';
import { Image } from 'components/core/Image';
import './NewCLPHero.scss';

export const enhance = compose(
	withSearchHandler,
);

export function NewCLPHero({ handleSearch, headline, subtitle }) {
	return (
		<>
			<div className="new-clp-hero">
				<Container className="container-clp-hero">
					<div className="section-content">
						<H2 strong className="subheading">
							{subtitle}
						</H2>
						<HH rounded>
							{headline}
						</HH>
						<ul className="section-points">
							<li>
								<Image src={comparePrices} className="icon" alt="Compare Prices" />
								Compare Storage Prices test
							</li>
							<li>
								<Image src={freeReservation} className="icon" alt="Free Reservation" />
								Free Reservation
							</li>
							<li>
								<Image src={exclusiveDeals} className="icon" alt="Find Exclusive Deals" />
								Find Exclusive Deals
							</li>
							<li>
								<Image src={noCreditCard} className="icon" alt="No Credit Card Required" />
								No Credit Card Required
							</li>
						</ul>
					</div>
					<div className="container-hero-search-box">
						<Paragraph className="search-box-label" color="black">
							<span>Enter Your ZIP Code</span>
							&nbsp;to Explore More Relevant Results
						</Paragraph>
						<SearchBox
							id="clp-sticky-search"
							inputLabel="Enter ZIP code"
							handleSearch={handleSearch}
							hideOnScroll
							buttonIcon={true}
							buttonText="Find Storage"
						/>
					</div>
				</Container>
			</div>
			<StickySearchBar triggerId="clp-sticky-search" handleSearch={handleSearch} />
		</>
	);
}

NewCLPHero.propTypes = {
	handleSearch: PropTypes.func,
	headline: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired
};

export default enhance(NewCLPHero);
